import ReactionIcon from './ReactionIcon';

export type { ReactionIconProps } from './ReactionIcon.types';

export default ReactionIcon;
